export default {
    fleetAdmins: 'fleetAdmins',
    fleetManagers: 'fleetManagers',
    localAdmins: 'localAdmins',
    users: 'users',
    assists: 'assists',
    problem: 'problem',
    overdue: 'overdue'
}
